module.exports = __webpack_public_path__ + "media/images/business/illust-used_fee-3bf011aa1338c13a3bc564a1d3f13c36.svg";